const wowApp = require('angular').module('wowApp.common');

wowApp.service('FeatureService', [require('./feature.service')]);



// WEBPACK FOOTER //
// ./src/common/feature/index.js